export default __webpack_public_path__ + "static/media/arrow-down-up.94dfb5ff.svg";